module.exports = __webpack_public_path__ + "static/media/q_nav_7_selected.d041b412.svg";